import { validateForm } from '../../Form/src/modules/validation';

const emailTrialForms = document.querySelectorAll('.mp-email-trial-form');

emailTrialForms.forEach((form) => {
	form.addEventListener('submit', (event) => {
		event.preventDefault();
		if (!validateForm(form)) {
			// Stop propagation if the form is not valid
			// * This way Google Tag Manager's listener won't receive the bubbling submit event
			event.stopPropagation();
		} else {
			window.location.assign(`${form.getAttribute('action')}?email=${form.querySelector('input[type="email"]').value}`);
		}
	});
});
